
<div class="max-w-3xl mx-auto bg-white dark:bg-white border-8 border-primary p-8 shadow-lg rounded-lg">
  <div class="registration-content">
      <a
      (click)="toggleRegister()"
      href="javascript:;"
      class="flex gap-2 border-b border-transparent p-4 !outline-none hover:border-azulOscuro hover:text-primary"
  >
      <icon-arrow-backward />
     {{ 'WORKSHOP-FORM.BACK' | translate }}
  </a>
  <h2 class="text-2xl font-bold text-center text-gray-700 mb-6"><img src="../../../../assets/images/title-taller.gif" alt=""></h2>

  <form [formGroup]="registroForm" (ngSubmit)="onSubmit()" class="space-y-4">

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
              <label class="block text-gray-600 font-medium"> {{ 'WORKSHOP-FORM.NAMES' | translate }} </label>
              <input type="text" placeholder="Ingresa tu nombre" class="w-full p-2 border border-primary rounded-lg focus:ring focus:ring-blue-300" formControlName="names">
              <div class="text-red-500 text-sm mt-1" *ngIf="registroForm.get('names')?.errors?.['required'] && registroForm.get('names')?.touched">
                  {{ 'WORKSHOP-FORM.REQUIRED-NAMES' | translate }}
              </div>
          </div>
          <div>
              <label class="block text-gray-600 font-medium">{{ 'WORKSHOP-FORM.LASTNAMES' | translate }}</label>
              <input type="text" placeholder="Ingresa tus apellidos" class="w-full p-2 border border-primary  rounded-lg focus:ring focus:ring-blue-300" formControlName="lastnames">
              <div class="text-red-500 text-sm mt-1" *ngIf="registroForm.get('lastnames')?.errors?.['required'] && registroForm.get('lastnames')?.touched">
                  {{ 'WORKSHOP-FORM.REQUIRED-LASTNAMES' | translate }}
              </div>
          </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
              <label class="block text-gray-600 font-medium">{{ 'WORKSHOP-FORM.COUNTRY' | translate }}</label>
              <select class="w-full p-2 border border-primary  rounded-lg focus:ring focus:ring-blue-300" formControlName="contry" (change)="onPaisChange()">
              <option value="" disabled selected> {{ 'WORKSHOP-FORM.SELECT-COUNTRY' | translate }} </option>
              <option *ngFor="let country of countries" [value]="country.cca2">{{ country.name.common }}</option>
          </select>
          </div>

          <div>
              <label class="block text-gray-600 font-medium"> {{ 'WORKSHOP-FORM.DEPARTAMENT' | translate }} </label>
            <select class="w-full p-2 border border-primary  rounded-lg focus:ring focus:ring-blue-300" formControlName="departament" (change)="getAvailableCityByStateCountryCode()" [disabled]="!states.length">
              <option value="" disabled selected>{{ 'WORKSHOP-FORM.SELECT-DEPARTAMENT' | translate }}</option>
              <option *ngFor="let state of states" [value]="state.state_code">{{ state.state_name }}</option>
            </select>
          </div>

          <div>
            <label class="block text-gray-600 font-medium">{{ 'WORKSHOP-FORM.CITY' | translate }}</label>
            <select class="w-full p-2 border border-primary  rounded-lg focus:ring focus:ring-blue-300" formControlName="cities"  [disabled]="!cities.length">
              <option value="" disabled selected>{{ 'WORKSHOP-FORM.SELECT-CITY' | translate }}</option>
              <option *ngFor="let citie of cities" [value]="citie.city_code">{{ citie.city_name }}</option>
          </select>
          </div>
        </div>

      <div>
          <label class="block text-gray-600 font-medium">{{ 'WORKSHOP-FORM.NAME-WORKSHOP' | translate }}</label>
          <input type="text" placeholder="Ingresa el nombre de tu taller" class="w-full p-2 border border-primary  rounded-lg focus:ring focus:ring-blue-300" formControlName="workshopName">
          <div class="text-red-500 text-sm mt-1" *ngIf="registroForm.get('workshopName')?.errors?.['required'] && registroForm.get('workshopName')?.touched">
              {{ 'WORKSHOP-FORM.REQUIRED-NAME-WORKSHOP' | translate }}
          </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
              <label class="block text-gray-600 font-medium">{{ 'WORKSHOP-FORM.PHONE' | translate }}</label>
              <input type="tel" placeholder="Ingresa tu telefono" class="w-full p-2 border border-primary  rounded-lg focus:ring focus:ring-blue-300" formControlName="phone">
              <div class="text-red-500 text-sm mt-1" *ngIf="registroForm.get('phone')?.errors?.['required'] && registroForm.get('phone')?.touched">
                  {{ 'WORKSHOP-FORM.REQUIRED-PHONE' | translate }}
              </div>
          </div>
          <div>
              <label class="block text-gray-600 font-medium">{{ 'WORKSHOP-FORM.EMAIL' | translate }}</label>
              <input type="email" placeholder="Ingresa tu correo eletronico" class="w-full p-2 border border-primary  rounded-lg focus:ring focus:ring-blue-300" formControlName="email">
              <div class="text-red-500 text-sm mt-1" *ngIf="registroForm.get('email')?.errors?.['required'] && registroForm.get('email')?.touched">
                  {{ 'WORKSHOP-FORM.REQUIRED-EMAIL' | translate }}
              </div>
          </div>
      </div>
      <div>
        <label class="block text-gray-600 font-medium">{{ 'WORKSHOP-FORM.TYPE-VEHICLE' | translate }}</label>
        <ng-select
        [items]="listVehicleTypesAll"
        bindLabel="name"
        class="custom-multiselect"
        formControlName="selectVehicleType"
        [multiple]="true"
        [clearable]="false"
        placeholder="Seleccione una opción"
        (change)="onSelectVehicleTypeChange()"
        [closeOnSelect]="false">
        </ng-select>

      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-gray-600 font-medium">{{ 'WORKSHOP-FORM.CATEGORY' | translate }}</label>
          <select class="w-full p-2 border border-primary  rounded-lg focus:ring focus:ring-blue-300" formControlName="selectCategory" (change)="onSelectCategoryChange()">
            <option value="" disabled selected>{{ 'WORKSHOP-FORM.SELECT-TYPE-VEHICLE' | translate }} </option>
            <option *ngFor="let category of serviceCenterCategories" [value]="category._id">{{ category.name }}</option>
          </select>


        </div>
        <div>
          <label class="block text-gray-600 font-medium">{{ 'WORKSHOP-FORM.SERVICE-CATEGORY' | translate }}</label>
          <select class="w-full p-2 border border-primary  rounded-lg focus:ring focus:ring-blue-300" formControlName="selectServiceCategory" (change)="onSelectServiceCategoryChange()">
            <option value="" disabled selected>{{ 'WORKSHOP-FORM.SELECT-TYPE-VEHICLE' | translate }} </option>
            <option *ngFor="let service of serviceCenterCategoryServicesByCategory" [value]="service._id">{{ service.name }}</option>
          </select>
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>

          <label class="block text-gray-600 font-medium">{{ 'WORKSHOP-FORM.SERVICE-CATEGORY-2' | translate }}</label>

          <ng-select
            [items]="services"
            bindLabel="name"
            class="custom-multiselect"
            formControlName="selectService"
            [multiple]="true"
            [clearable]="false"
            placeholder="Seleccione una opción"
            [closeOnSelect]="false">

          </ng-select>
        </div>
        <div class="flex items-end">
          <button type="button" class="mt-2 w-full bg-azulOscuro text-white p-2 rounded-lg hover:bg-primary transition" (click)="addService()">
            {{ 'WORKSHOP-FORM.ADD-VEHICLE' | translate }}
        </button>
        </div>
        <div>
          <div class="flex flex-wrap justify-end">
            <span class="badge bg-primary p-0 ltr:pr-4 rtl:pl-4 my-4 rounded-full flex items-center text-base ml-2" *ngFor="let service of listCategorySelected; let i = index">
              <img src="https://w7.pngwing.com/pngs/640/918/png-transparent-logo-car-workshop-yamaha-hand-sports-equipment-fictional-character-thumbnail.png" alt="" class="w-10 h-10 rounded-full object-cover" />
              <span class="ltr:ml-2 rtl:mr-2">{{service.name}}</span>
              <span class="ltr:ml-4 rtl:mr-4 cursor-pointer hover:opacity-90" (click)="removeService(i)">x</span>
            </span>
          </div>
        </div>
      </div>
      <div class="file-upload-container">
        <div class="file-upload">
          <label for="file1" class="file-upload-title">Subir Imagen 1</label>
          <input type="file" id="file1" class="file-input" (change)="onFileSelected($event, 1)">
        </div>
        <div class="file-upload">
            <label for="file2" class="file-upload-title">Subir Imagen 2</label>
            <input type="file" id="file2" class="file-input"  (change)="onFileSelected($event, 2)">
        </div>
        <div class="file-upload">
          <label for="file3" class="file-upload-title">Subir Imagen 3</label>
          <input type="file" id="file3" class="file-input" (change)="onFileSelected($event, 3)">
        </div>
        <div class="file-upload">
          <label for="file4" class="file-upload-title">Subir Imagen 4</label>
          <input type="file" id="file4" class="file-input" (change)="onFileSelected($event, 4)">
        </div>
        <div class="file-upload">
          <label for="file5" class="file-upload-title">Subir Imagen 5</label>
          <input type="file" id="file5" class="file-input" (change)="onFileSelected($event, 5)">
        </div>
        <div class="file-upload">
          <label for="file6" class="file-upload-title">Subir Imagen 6</label>
          <input type="file" id="file6" class="file-input" (change)="onFileSelected($event, 6)">
        </div>
        <div class="file-upload">
          <label for="file7" class="file-upload-title">Subir Imagen 7</label>
          <input type="file" id="file7" class="file-input" (change)="onFileSelected($event, 7)">
        </div>
        <div class="file-upload">
          <label for="file8" class="file-upload-title">Subir Imagen 8</label>
          <input type="file" id="file8" class="file-input" (change)="onFileSelected($event, 8)">
        </div>
    </div>


      <div>
          <label class="block text-gray-600 font-medium">{{ 'WORKSHOP-FORM.LOCATION' | translate }}</label>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input type="text" class="w-full p-2 border border-primary  rounded-lg bg-gray-100" formControlName="latitud" readonly placeholder="Latitud">
              <input type="text" class="w-full p-2 border border-primary  rounded-lg bg-gray-100" formControlName="longitud" readonly placeholder="Longitud">
          </div>
          <button type="button" class="mt-2 w-full bg-azulOscuro text-white p-2 rounded-lg hover:bg-primary transition" (click)="obtenerUbicacion()">
            {{ 'WORKSHOP-FORM.GET-LOCATION' | translate }}
          </button>
          <google-map *ngIf="coords.lat != 0"  [center]="coords" [zoom]="14" width="100%" >
            <map-marker *ngIf="coords.lat != 0" [position]="coords" [title]="'Tu ubicación'" [icon]="userIconPosition" [options]="mapOptions"></map-marker>
         </google-map>
        </div>

      <div class="flex items-center space-x-2">
          <input type="checkbox" formControlName="terms" id="terms" class="w-5 h-5">
          <label for="terms" class="text-gray-600">{{ 'WORKSHOP-FORM.TERMS_CONDITIONS' | translate }}</label>
      </div>

      <button type="submit" class="w-full bg-primary text-white p-3 rounded-lg font-semibold cursor-pointer hover:bg-azulOscuro transition" [disabled]="!registroForm.valid">
          {{ 'WORKSHOP-FORM.REGISTER' | translate }}
      </button>
  </form>
  <div class="stars">
</div>
</div>
